$('.js-collapseToggle').on('click', (e) => {
  const wrap = $(e.currentTarget).parents('.js-collapse')
  const title = $(e.currentTarget).data('title')
  const titleSec = $(e.currentTarget).data('title-sec')
  const titleEl = $(e.currentTarget).find('[data-collapse-title]')
  const container = wrap.find('[data-collapse-container]')
  const listHeight = wrap.find('[data-collapse-list]').height()

  $(e.currentTarget).toggleClass('_is_rotate_icon')

  if ($(e.currentTarget).hasClass('_is_rotate_icon')) {
    wrap.addClass('_is_full_height')
    container.css('height', listHeight)
    titleEl.text(titleSec)
  } else {
    wrap.removeClass('_is_full_height')
    container.css('height', 300)
    titleEl.text(title)
  }
})
